
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ApiGateway, Holiday, PageOptions } from 'cw-backend';
import { CwUtils } from 'cw-utils';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class HolidayListProvider implements Resolve<any> {
    holiday: Holiday[];
    holidayEdit: Holiday;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        this.currentPage = this.state?.currentPage;
        this.holidayEdit = this.state?.currentHoliday;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
            this.pageOptions.fieldSort = 'name';
        }
        else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = 'name';
        }
        return new Promise<void>((resolve, reject) => {
            Promise.all([
                this.getPage(this.pageOptions)
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    get(id: number): Observable<Holiday> {
        if (!id) {
            return null;
        }
        return this.gw.get('holiday/:id', { id: id });
    }

    get currentHoliday(): Holiday {
        return this.holidayEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('holiday/').subscribe((res: HttpResponse<any>) => {
                this.holiday = res.body;
                resolve(res);
            }, reject);
        });

    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('holiday/search', pageOptions).subscribe((res: HttpResponse<any>) => {
                if (!CwUtils.compare(this.holiday, res.body.content) && res.body.content.length > 0) {
                    this.holiday = res.body.content;
                    this.onDataChanged.next(this.holiday);
                }
                else {
                    this.holiday = res.body.content;
                };
                resolve(res);
            }, reject);
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }

    checkHoliday(companyId, date) {
        if (companyId) {
            companyId = `?companyId=${companyId}`
        }
        if (date) {
            date = `&date=${date}`
        }

        return new Promise<any>((resolve, reject) => {
            this.gw.post(`holiday/check${companyId}${date}`,)
                .subscribe({
                    next(value) {
                        resolve(value);
                    },
                })
        });
    }
}

